import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {AppState} from '../interfaces/app-state.interface';
import {UploadSelectors} from '../store/selectors/upload.selectors';
import {UploadActions} from '../store/actions/upload.actions';
import {DeleteDialogSelectors} from '../store/selectors/delete-dialog.selectors';
import {DocumentsActions} from '../store/actions/documents.actions';


@Injectable({providedIn: 'root'})
export class UiService {

  private uploadDialog?: MatDialogRef<any>;
  private deleteConfirmDialog?: MatDialogRef<any>;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
  ) {
    this.initUploadDialog();
    this.initDeleteConfirmDialog();
  }

  private initUploadDialog(): void {
    this.store.select(UploadSelectors.isDialogOpen).subscribe(isOpen => {
      if (isOpen) {
        // Lazy-Load der Dialog-Komponente
        import('../modules/upload-dialog/upload-dialog.component').then(m => {
          this.uploadDialog = this.dialog.open(m.UploadDialogComponent, {
            width: '600px',
            minWidth: '480px',
            maxWidth: '95vw',
            autoFocus: false,
            disableClose: true,
            restoreFocus: false,
            panelClass: 'upload-dialog',
          });

          // Bei Schließen durch Backdrop/ESC: State zurücksetzen
          this.uploadDialog.afterClosed().subscribe(() => {
            this.store.dispatch(UploadActions.resetState());
          });
        });
      } else {
        this.uploadDialog?.close();
      }
    });
  }

  private initDeleteConfirmDialog(): void {
    this.store.select(DeleteDialogSelectors.isOpen).subscribe(isOpen => {
      if (isOpen) {
        // Lazy-Load der Dialog-Komponente
        import('../modules/delete-confirm-dialog/delete-confirm-dialog.component').then(m => {
          this.deleteConfirmDialog = this.dialog.open(m.DeleteConfirmDialogComponent, {
            width: '450px',
            maxWidth: '95vw',
            autoFocus: false,
            disableClose: false,
            restoreFocus: false,
            panelClass: 'delete-confirm-dialog',
          });

          // Bei Schließen durch Backdrop/ESC: State zurücksetzen
          this.deleteConfirmDialog.afterClosed().subscribe(() => {
            this.store.dispatch(DocumentsActions.closeDeleteConfirmDialog());
          });
        });
      } else {
        this.deleteConfirmDialog?.close();
      }
    });
  }
}
